import { jsx as d } from "react/jsx-runtime";
import o from "react";
function x({
  rootComponentName: i,
  defaultContext: t
}) {
  const c = o.createContext(
    t
  );
  function r(n) {
    const { children: e, ...s } = n, a = o.useMemo(() => s, [s]);
    return /* @__PURE__ */ d(c.Provider, { value: a, children: e });
  }
  function u(n = !1) {
    const e = o.useContext(c);
    if (e) return e;
    if (t !== void 0) return t;
    if (n)
      throw new Error(
        `\`${i}\` must be used within a \`${r.displayName}\` component.`
      );
  }
  return r.displayName = i + "Provider", [r, u];
}
export {
  x as c
};
//# sourceMappingURL=create-context.DwEJDSIV.js.map
